import { dropNoiseExceptions } from "./exception-filter";

const LOW_INTENT_PUBLIC_ROUTE_PREFIXES = [
  "/calculators",
  "/tools",
  "/learning-center",
] as const;

export const clientApiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
export const clientApiHost =
  process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://r.upside.tools";
export const clientUiHost =
  process.env.NEXT_PUBLIC_POSTHOG_UI_HOST || "https://us.posthog.com";

export const basePosthogConfig = {
  api_host: clientApiHost,
  ui_host: clientUiHost,
  defaults: "2026-01-30" as const,
  person_profiles: "always" as const,
  capture_pageview: "history_change" as const,
  autocapture: false,
  capture_exceptions: true,
  before_send: dropNoiseExceptions,
  debug: process.env.NODE_ENV !== "production",
  session_recording: {
    recordCrossOriginIframes: false,
    maskAllInputs: true,
    maskTextSelector: "*",
  },
  enable_recording_console_log: false,
  capture_pageleave: true,
};

export function shouldDisablePosthogSessionRecording(
  pathname?: string | null,
): boolean {
  if (!pathname) return false;
  const normalizedPathname = pathname.split(/[?#]/, 1)[0]?.replace(/\/$/, "") || "/";

  if (normalizedPathname === "/") return true;

  return LOW_INTENT_PUBLIC_ROUTE_PREFIXES.some(
    (prefix) =>
      normalizedPathname === prefix || normalizedPathname.startsWith(`${prefix}/`),
  );
}

export function createPosthogConfig(pathname?: string | null) {
  if (!shouldDisablePosthogSessionRecording(pathname)) {
    return basePosthogConfig;
  }

  return {
    ...basePosthogConfig,
    disable_session_recording: true,
  };
}
